import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const BrandingContext = createContext(null);

const knownFontsMap = {
  "-apple-system": null,
  blinkmacsystemfont: null,
  "segoe ui": null,
  roboto: "Roboto",
  oxygen: "Oxygen",
  impact: null,
  "arial narrow bold": null,
  ubuntu: "Ubuntu",
  cantarell: "Cantarell",
  "fira sans": "Fira+Sans",
  "droid sans": "Droid+Sans",
  "helvetica neue": null,
  "bebas neue": "Bebas+Neue",
  "sans-serif": null,
  verdana: null,
};

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(null);
  const [loading, setLoading] = useState(false);

  const tenantId =
    typeof window !== "undefined" && window.location.hostname
      ? window.location.hostname.split(".")[0] !== "localhost"
        ? window.location.hostname.split(".")[0]
        : "defaultTenant"
      : null;

  const loadGoogleFont = (fontString) => {
    if (!fontString) return;
    const primary = (fontString.split(",")[0] || "")
      .replace(/['\"]/g, "")
      .trim()
      .toLowerCase();
    const gf = knownFontsMap[primary];
    if (!gf) return;
    // encode each segment but preserve '+' separators (Google Fonts expects '+' between words)
    const familyParam = gf.split("+").map(encodeURIComponent).join("+");
    const href = `https://fonts.googleapis.com/css2?family=${familyParam}&display=swap`;
    const exists = Array.from(
      document.querySelectorAll('link[rel="stylesheet"]')
    ).some((l) => l.href && l.href.includes(familyParam));
    if (!exists) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
    }
  };

  const applyFont = (fontString) => {
    if (!fontString || typeof document === "undefined") return;
    // try {
    //   document.body.style.fontFamily = fontString;
    // } catch (err) {
    //   // ignore
    // }
    loadGoogleFont(fontString);
  };

  const fetchBranding = async () => {
    if (!tenantId) return;
    setLoading(true);
    try {
      const res = await axios.get("/api/branding/getallbranding", {
        headers: { "X-Tenant-ID": tenantId },
      });
      const data = res.data || {};
      setBranding(data);
      if (data.headingFont) applyFont(data.headingFont);
    } catch (err) {
      console.error("Error fetching branding:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBranding();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId]);

  return (
    <BrandingContext.Provider
      value={{ branding, loading, refresh: fetchBranding }}
    >
      {children}
    </BrandingContext.Provider>
  );
};

export const useBrandingContext = () => useContext(BrandingContext);

export default BrandingContext;
